import { gql } from 'urql';

export const LIST_INGRESOS = gql`
  query ListIngresosStock($filters: MovimientoStockFilterInput, $pagination: PaginationInput) {
    listIngresosStock(filters: $filters, pagination: $pagination) {
      items {
        id
        fecha
        tipo
        proveedorNombre
        sucursalId
        observacion
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_INGRESO = gql`
  query GetIngresoStock($id: ID!) {
    getIngresoStock(id: $id) {
      id
      fecha
      tipo
      observacion
      proveedorNombre
      sucursalId
      usuario
      items {
        id
        descripcion
        cantidad
        costoUnit
        subtotal
      }
    }
  }
`;

export const REGISTRAR_INGRESO = gql`
  mutation RegistrarIngreso($input: RegistrarIngresoInput!) {
    registrarIngreso(input: $input) {
      id
    }
  }
`;
